//messages.js
export default {
    //Posworld
    dashboard: 'Dashboard',
    settings: 'Instellingen',
    mailsettings: 'Mail instellingen',
    editor_newappoint: 'Nieuwe afspraak',
    editor_appreminder: 'Herinnering',
    editor_appdelete : 'Afspraak verwijderen',
    editor_appnewcust : 'Nieuwe klant',
    editor_appgetpasswd : 'Wachtwoord opvragen',
    onlinereservation: 'Online reservatie',
    posworld: 'Algemeen',
    customers: 'Klanten',
    scheduler: 'Agenda',
    stock: 'Voorraad',
    products: 'Producten',
    productsgamma: 'Productengamma',
    basicdata: 'Basisgegevens',
    services: 'Diensten',
    suppliers: 'Leveranciers',
    categories: 'Categorieën',
    addtostock: 'Toevoegen voorraad',
    useinshop: 'Verbruik',
    reports: 'Rapportage',
    search: 'Zoeken',
    logOut: 'Afmelden',
    loginNow: 'Inloggen',
    enterUsernameAndPasswordToAccessControlPanelOf: 'Geef gebruikersnaam en wachtwoord op om in te loggen op',
    bySigningUpYouAgreeTo: 'Bij inloggen ga je akkoord op',
    termsOfService: 'Voorwaarden / privacy',
    loginToAdmin: 'Salonworld onlinemodule',
    sales: 'Omzet',
    transactions: 'Transacties',
    appointments: 'Afspraken',
    appointthisweek: 'Afspraken deze week',
    appointdevider: 'Afspraakverdeling',
    customerdet: 'Klantgegevens',
    customerstickesdone: 'Klanten afgerekend',
    appointmentchanges: 'Nieuwe afspraken / gewijzigde afspraken',
    visits: 'Bezoek',
    user: 'Medewerker',
    users: 'Medewerkers',
    userdet: 'Detail medewerker / ruimte',
    chat: 'chat',
    recentChat : 'Recente chat',
    previousChats : 'Vorige chats',
    fullScreen: 'Volledig scherm',
    reload: 'herladen',
    close: 'Sluit',
    categoriesserv: 'Categorie diensten',
    categoriesprod: 'Categorie producten',
    categorydet: 'Detail categorie',
    workhours: 'Werkuren',
    exceptionhours : 'Uitzonderingsuren',
    onlineservices : 'Behandelingen online uitvoerbaar',
    monthreport : 'Maandrapport',
    salesreport : 'Omzetrapport',
    stockreport : 'Voorraad rapport',
    inventoryreport : 'Inventaris rapport',
    inventory : 'Inventaris',
    monthTotals : 'Maandtotalen',
    paymentkind : 'Betaalwijze',
    salesinclvat : 'Omzetverdeling incl. Btw',
    vat : 'Btw',
    totals : 'Totalen',
    monthservices : 'Maandrapport diensten',
    monthproducts : 'Maandrapport producten',
    monthusersreport : 'Rapport medewerkers',
    smsconfig : 'SMS instellingen',
    smssettings : 'SMS configuratie',
    smshistorique : 'SMS historiek',
    clients : 'Klanten',
    modules : 'Modules',
    mailchimp : 'Mailchimp nieuwsbrief',
    categoryorder : 'Inwerken volgens categorie',
    onlinecontrol : 'Controle online reservatie',
    support : 'support',
    agenda : 'agenda',
    appbasketmessage : 'onlineres. winkelmandbericht',
    export : 'export'
}
